export default __webpack_public_path__ + "static/media/C0001.88bccac6.png";